import { useEffect, useState } from 'react';
import { Col, Divider, Row, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import { WebApiCompanyDtoCompanyAdministratorResultDto, WebApiCompanyDtoCompanyUserDto } from '../../Repository/eventbookyapi';
import { useAuth } from '../../Contexts/AuthContext';
import { TextService } from '../../Services/TextService';
import LeftMenu from '../Users/LeftMenu';
import { CompanyService } from '../../Services/CompanyService';
import AdminList from '../../Components/Users/AdminList';
import LeftMenuSettings from './LeftSettings';
import Paragraph from 'antd/lib/typography/Paragraph';
import Page from '../../Components/Page/Page';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';
import LeftMenuCommunicate from '../Communicate/LeftCommunicate';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';

const Administrators = () => {
  const [adminResult, setAdminResult] = useState({} as WebApiCompanyDtoCompanyAdministratorResultDto);
  const { user } = useAuth();
  const GetText = TextService.GetText;

  useEffect(() => {
    loadAdmins();
  }, []);

  const loadAdmins = () => {
    CompanyService.GetCompanyAdministrators().then(result => {
      setAdminResult(result);
    });
  }

  const helpContent_se = <>
    <Paragraph>Administratörer har olika behörighetsnivåer beroende på roll:</Paragraph>
    <ul>
      <li><b>Full behörighet (max 2 st)</b> – Har tillgång till hela systemet. Kan ändra organisationsinställningar, hantera medlemmar, skicka utskick och administrera andra administratörer.</li>
      <li><b>Redigeringsbehörighet</b> – Kan redigera medlemmar och skicka e-post/sms-utskick, men har inte tillgång till organisationsinställningar.</li>
      <li><b>Läsbehörighet</b> – Kan enbart läsa information i systemet. Inga ändringar kan göras.</li>
    </ul>
    <Paragraph><b>Så här går det till:</b> När du lagt till en e-postadress skickas ett välkomstmail till administratören. I mailet finns en länk där de skapar sitt konto med namn och lösenord.</Paragraph>
  </>;

  const helpContent_en = <>
    <Paragraph>Administrators have different permission levels depending on their role:</Paragraph>
    <ul>
      <li><b>Full rights (max 2)</b> – Full access to the entire system. Can change organization settings, manage members, send emails/SMS, and administer other administrators.</li>
      <li><b>Edit rights</b> – Can edit members and send email/SMS, but has no access to organization settings.</li>
      <li><b>Read rights</b> – Read-only access. No changes can be made in the system.</li>
    </ul>
    <Paragraph><b>How it works:</b> Once you add an email address, the administrator will receive a welcome email with a link to create their account with a name and password.</Paragraph>
  </>;

  return <LayoutLeftMenu title={GetText("Admins_AdminsTitle")} pageHelpContent={getCurrentLanguage() === 'se' ? helpContent_se : helpContent_en} menu={<LeftMenuSettings selected={"admins"} />}>
    <Paragraph>{GetText("Admins_Description")}</Paragraph>
    {
      adminResult != null ? <>

        <AdminList user={user} adminResult={adminResult} loadAdmins={loadAdmins} />
      </>
        : <i>{GetText("Groups_NoGroupsSelected")}</i>
    }
  </LayoutLeftMenu>
};

export default Administrators;